import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { useKey } from '../../contexts/KeysContext';
import StripeForm from './Stripe';

const propTypes = {
    api: PropTypes.shape({
        createIntent: PropTypes.func.isRequired,
        confirmIntent: PropTypes.func.isRequired,
    }),
    amount: PropTypes.number,
    amountEditable: PropTypes.bool,
    currency: PropTypes.string,
    onSuccess: PropTypes.func,
    className: PropTypes.string,
};

const PaymentForm = ({
    api = null,
    amount = null,
    amountEditable = false,
    currency = 'CAD',
    onSuccess = null,
    className = null,
}) => {
    const { locale } = useIntl();
    const stripeKey = useKey('stripe');
    const stripePromise = useMemo(
        () =>
            loadStripe(stripeKey, {
                locale,
            }),
        [stripeKey, locale],
    );
    return (
        <Elements stripe={stripePromise}>
            {api !== null ? (
                <StripeForm
                    api={api}
                    amount={amount}
                    amountEditable={amountEditable}
                    currency={currency}
                    onSuccess={onSuccess}
                    className={className}
                />
            ) : null}
        </Elements>
    );
};
PaymentForm.propTypes = propTypes;

export default PaymentForm;
